<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="关键字">
                    <el-input v-model="query.keyword" placeholder="请输入评选投票标题" clearable></el-input>
                </el-form-item>
<!--                <el-form-item label="类型">-->
<!--                    <el-select v-model="query.course_type" placeholder="全部" clearable>-->
<!--                        <el-option v-for="(item, index) in select_type_array" :label="item" :value="index" :key="index"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="投票时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--添加等级-->
        <div class="common-level-rail"></div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="log_id" label="记录ID" width="80"></el-table-column>
                    <el-table-column prop="uesr" label="投票用户" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.user ? scope.row.user.nickName : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="vote" label="投票评选">
                        <template slot-scope="scope">
                            {{ scope.row.vote ? scope.row.vote.title : '' }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="vote" label="作品/参赛者">
                        <template slot-scope="scope">
                            {{ scope.row.cmpe ? scope.row.cmpe.title : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="vote_num" label="票数" width="70"></el-table-column>
                    <el-table-column prop="create_time" label="投票时间" width="150"></el-table-column>
<!--                    <el-table-column fixed="right" label="操作" width="100">-->
<!--                        <template slot-scope="scope">-->
<!--&lt;!&ndash;                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/course/add'">编辑</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/course/del'">删除</el-button>&ndash;&gt;-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
<!--        <edit ref="edit" @fetch-data="refresh"></edit>-->

    </div>
</template>

<script>
    import { voteLog } from '@/api/education';


    export default {
        components: {

        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    course_type: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],

            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                voteLog(this.query).then((result)=>{
                    this.loading = false
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.course_type = val
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/vote/log/index.vue